export const pluginID = 'customButtons';
